/**
 * @generated SignedSource<<ca4ea6127d1f63d30e914e8dc1d55cc1>>
 * @relayHash 7f7cc3b44ad9e89bcdd23559a237ea6c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f7cc3b44ad9e89bcdd23559a237ea6c

import { ConcreteRequest } from 'relay-runtime';
export type usePartnerInVideoCallChannelSubscription$variables = Record<PropertyKey, never>;
export type usePartnerInVideoCallChannelSubscription$data = {
  readonly partnerInVideoCallChanged: {
    readonly appointmentId: string;
    readonly isPartnerInVideoCall: boolean;
  };
};
export type usePartnerInVideoCallChannelSubscription = {
  response: usePartnerInVideoCallChannelSubscription$data;
  variables: usePartnerInVideoCallChannelSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PartnerInVideoCallChangedResult",
    "kind": "LinkedField",
    "name": "partnerInVideoCallChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appointmentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPartnerInVideoCall",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePartnerInVideoCallChannelSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePartnerInVideoCallChannelSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "7f7cc3b44ad9e89bcdd23559a237ea6c",
    "metadata": {},
    "name": "usePartnerInVideoCallChannelSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "ed088a6afc8bb888850d152e8d94392f";

export default node;
